export const REPORT_ID = 'slide-32';
export const SLIDE_NUMBER = 32;